import { assign } from 'lodash-es';
import { FETCH_SHIPMENTS_SUCCEEDED, SORT_SHIPMENTS_SUCCEEDED, SELECT_ALL_VISIBLE_SHIPMENT } from './list.actions';

export const list = (state = {}, action) => {
  switch (action.type) {
    case FETCH_SHIPMENTS_SUCCEEDED:
      return assign({}, state, { fetched: true, items: action.data, pagination: action.pagination });

    case SORT_SHIPMENTS_SUCCEEDED:
      return assign({}, state, { fetched: true, items: action.data, total: action.total });

    case SELECT_ALL_VISIBLE_SHIPMENT:
      if (state['fetched'] === true) {
        return assign({}, state, { fetched: true, items: state['items'].map(s => {
            s.checked = action.data;
            return s;
          }), total: state['total'] });
      } else {
        return state;
      }

    default:
      return state;
  }
};
